<template>
  <!-- UNDER MAINTENANCE (Mobile / Tablet) -->

  <!-- DESKTOP LOGIN -->
  <section
    class="min-h-screen flex flex-col items-center py-20 bg-cover bg-center px-6"
    :style="{ backgroundImage: `url(${require('@/assets/images/bg.png')})` }"
  >
    <!-- LOGO -->
    <img src="@/assets/images/login-logo.svg" alt="Logo" class="h-36 mb-8 drop-shadow-lg" />

    <form class="w-full max-w-md space-y-5" @submit.prevent="loginHandler">
      <!-- Email -->
      <div>
        <label class="block text-sm font-medium text-primarydark mb-1 drop-shadow-sm">
          Email
        </label>
        <input
          required
          v-model="username"
          type="text"
          autocomplete="username"
          placeholder="you@example.com"
          class="w-full px-4 py-3 rounded-lg border border-white bg-white/90 text-gray-900 placeholder-gray-500 shadow-sm focus:ring-2 focus:ring-secondaryPalette outline-none"
        />
      </div>

      <!-- Password -->
      <div>
        <label class="block text-sm font-medium text-primarydark mb-1 drop-shadow-sm">
          Password
        </label>
        <input
          required
          v-model="password"
          type="password"
          autocomplete="current-password"
          placeholder="••••••••"
          class="w-full px-4 py-3 rounded-lg border border-white bg-white/90 text-gray-900 placeholder-gray-500 shadow-sm focus:ring-2 focus:ring-secondaryPalette outline-none"
        />
      </div>

      <!-- Button -->
      <button
        type="submit"
        class="w-full bg-primarydark hover:bg-primarydarkhover text-white font-semibold py-3 rounded-lg shadow-md transition"
      >
        <span v-if="!renderLoading">Sign In</span>
        <span v-else>
          <svg
            class="animate-spin h-5 w-5 mr-2 text-white inline-block"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              class="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              stroke-width="4"
            />
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
          </svg>
          Signing in...
        </span>
      </button>

      <!-- Error -->
      <p v-show="errorVisible" class="text-red-400 text-center mt-2 drop-shadow-sm">
        {{ errorMessage }}
      </p>
    </form>
  </section>
</template>

<script>
import encryptHandler from '@/utils/encrypt';
import errorHandler from '@/utils/errorhandler';
import { inject, reactive, ref, toRefs, onMounted, onUnmounted } from 'vue';
import { useRouter } from 'vue-router';

export default {
  setup() {
    const { encryptFile } = encryptHandler();
    const { errorDetails, errorMessage, errorVisible } = errorHandler();
    const axios = inject('$axios');
    const store = inject('$store');
    const router = useRouter();

    const formData = reactive({
      username: null,
      password: null
    });

    const renderLoading = ref(false);
    const isMobile = ref(false);

    // Detect screen size
    const checkDevice = () => {
      isMobile.value = window.innerWidth <= 1024;
    };

    onMounted(() => {
      checkDevice();
      window.addEventListener('resize', checkDevice);
    });

    onUnmounted(() => {
      window.removeEventListener('resize', checkDevice);
    });

    const loginHandler = async () => {
      try {
        renderLoading.value = true;

        const response = await axios.post('/api/auth/login', formData);

        if (response.data.raw?.token) {
          localStorage.setItem(process.env.VUE_APP_AUTH_TOKEN, response.data.raw.token);

          store.commit('getUserLogged', response.data.raw);

          router.push(`/portal/home/${encryptFile('iwc')}`);
        }
      } catch (error) {
        errorVisible.value = true;
        renderLoading.value = false;
        errorDetails(error);

        // hide error after 6s (fixed from setInterval)
        setTimeout(() => {
          errorVisible.value = false;
        }, 6000);
      }
    };

    return {
      ...toRefs(formData),
      loginHandler,
      errorMessage,
      errorVisible,
      renderLoading,
      encryptFile,
      isMobile
    };
  }
};
</script>
